var _rect, _ellipse, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopHeaderDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 668 666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334,0 C518.463106,0 668,149.089178 668,333 C668,516.910822 518.463106,666 334,666 C149.536894,666 0,516.910822 0,333 C0,149.089178 149.536894,0 334,0 Z M333.5,178 C246.515152,178 176,247.619721 176,333.5 C176,419.380279 246.515152,489 333.5,489 C420.484848,489 491,419.380279 491,333.5 C491,247.619721 420.484848,178 333.5,178 Z",
    id: "Combined-Shape",
    fill: "#CBF8FE",
    opacity: 0.108770461,
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE8AC",
    x: 132,
    y: 459,
    width: 14,
    height: 14,
    rx: 7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#EEBAD4",
    cx: 229,
    cy: 538.5,
    rx: 10,
    ry: 10.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C2EFF6",
    x: 265,
    y: 475,
    width: 16,
    height: 16,
    rx: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopHeaderDonut);
export default __webpack_public_path__ + "static/media/desktop-header-donut.08bdf84c813a33c10067ee6889b44716.svg";
export { ForwardRef as ReactComponent };